import React, { useCallback, useEffect, useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { ownerApi, inr, monthLabel, errText } from "@/lib/ownerApi";
import { Stat } from "./Overview";
import TeacherSalaryCard from "./TeacherSalaryCard";

const thisMonth = () => new Date().toISOString().slice(0, 7);

export default function SalaryMonth() {
  const [months, setMonths] = useState(null);
  const [month, setMonth] = useState(null);
  const [d, setD] = useState(null);
  useEffect(() => {
    ownerApi.get("/salary/rules").then(({ data }) => {
      setMonths(data.salary_months);
      setMonth(data.salary_months.includes(thisMonth()) ? thisMonth() : data.salary_months[0]);
    }).catch((e) => toast.error(errText(e)));
  }, []);
  const load = useCallback(() => month && ownerApi.get(`/salary/month/${month}`).then(({ data }) => setD(data)).catch((e) => toast.error(errText(e))), [month]);
  useEffect(() => { setD(null); load(); }, [load]);
  const download = async () => {
    try {
      const { data } = await ownerApi.get(`/salary/export/${month}`, { responseType: "blob" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(data); a.download = `PTG-salary-${month}.xlsx`; a.click();
    } catch (e) { toast.error("Export failed"); }
  };
  if (!months) return <Loader2 className="h-6 w-6 animate-spin text-emerald-800 mx-auto" />;
  return (
    <div className="space-y-5" data-testid="owner-salary-month">
      <div className="flex flex-wrap items-center gap-3">
        <Select value={month} onValueChange={setMonth}>
          <SelectTrigger className="w-48" data-testid="owner-salary-month-select"><SelectValue /></SelectTrigger>
          <SelectContent>{months.map((m) => <SelectItem key={m} value={m}>{monthLabel(m)}</SelectItem>)}</SelectContent>
        </Select>
        <Button variant="outline" onClick={download} data-testid="owner-salary-export"><Download className="h-4 w-4 mr-1" /> Excel register</Button>
        <span className="text-xs text-stone-500">Salary months: June – April (11). Uses live full-year Fees Due for each group.</span>
      </div>
      {!d ? <Loader2 className="h-6 w-6 animate-spin text-emerald-800 mx-auto" /> : (
        <>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
            <Stat label="Calculated" value={d.totals.calculated} cls="bg-white border-stone-200" testid="owner-salary-total-calc" />
            <Stat label="Net payable" value={d.totals.net_payable} cls="bg-white border-stone-200" testid="owner-salary-total-net" />
            <Stat label="Paid" value={d.totals.total_paid} cls="bg-emerald-50 border-emerald-200 text-emerald-900" testid="owner-salary-total-paid" />
            <Stat label="Outstanding" value={d.totals.outstanding} cls="bg-amber-50 border-amber-200 text-amber-900" testid="owner-salary-total-out" />
          </div>
          <div className="space-y-4">{d.teachers.map((t) => <TeacherSalaryCard key={`${t.key}-${month}-${t.status}`} t={t} month={month} onDone={load} />)}</div>
          <p className="text-xs text-stone-500">Total fees used this month: {Object.entries(d.group_totals).filter(([, v]) => v).map(([g, v]) => `${g} ${inr(v)}`).join(" · ")}</p>
        </>
      )}
    </div>
  );
}
